<div class="mt-3">
  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
